import * as Types from '../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClearActivityFeedBadgingMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ClearActivityFeedBadgingMutation = { __typename?: 'Mutation', clearActivityFeedBadging: boolean };


export const ClearActivityFeedBadgingDocument = gql`
    mutation ClearActivityFeedBadging {
  clearActivityFeedBadging
}
    `;
export type ClearActivityFeedBadgingMutationFn = Apollo.MutationFunction<ClearActivityFeedBadgingMutation, ClearActivityFeedBadgingMutationVariables>;

/**
 * __useClearActivityFeedBadgingMutation__
 *
 * To run a mutation, you first call `useClearActivityFeedBadgingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearActivityFeedBadgingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearActivityFeedBadgingMutation, { data, loading, error }] = useClearActivityFeedBadgingMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearActivityFeedBadgingMutation(baseOptions?: Apollo.MutationHookOptions<ClearActivityFeedBadgingMutation, ClearActivityFeedBadgingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearActivityFeedBadgingMutation, ClearActivityFeedBadgingMutationVariables>(ClearActivityFeedBadgingDocument, options);
      }
export type ClearActivityFeedBadgingMutationHookResult = ReturnType<typeof useClearActivityFeedBadgingMutation>;
export type ClearActivityFeedBadgingMutationResult = Apollo.MutationResult<ClearActivityFeedBadgingMutation>;
export type ClearActivityFeedBadgingMutationOptions = Apollo.BaseMutationOptions<ClearActivityFeedBadgingMutation, ClearActivityFeedBadgingMutationVariables>;